interface Config {
  local: AppConfig;
  localQa: AppConfig;
  localProd: AppConfig;
  qa: AppConfig;
  prod: AppConfig;
}

export type ENV = keyof Config;

interface AppConfig {
  env: ENV;
  bff: string;
  ordrServiceUrl: string;
  paymentServiceUrl: string;
  customerOnboardingServiceUrl: string;
  menuBuilderUrl: string;
  release: number;
  baseUrl: string;
  receiptUrl: string;
  hubUrl: string;
  showSubsections: boolean;
  /** Location IDs that may send trace headers. null = all locations allowed. */
  tracingLocationIds: number[] | null;
}

const releaseTag = (() => {
  const tag = Number.parseInt(import.meta.env['VITE_RELEASE_TAG'] ?? '', 10);
  return Number.isNaN(tag) ? 0 : tag;
})();

const getConfig: () => AppConfig = () => {
  // Defaults to local profile
  const env = (import.meta.env['VITE_ENV'] as ENV) || 'qa';
  const c: Config = {
    local: {
      baseUrl: 'http://localhost:1234',
      bff: `http://localhost:8086`,
      customerOnboardingServiceUrl: 'http://localhost:8086',
      env,
      hubUrl: `ws://localhost:8090/hub`,
      menuBuilderUrl: 'http://localhost:8084',
      ordrServiceUrl: 'http://localhost:8080/ws',
      paymentServiceUrl: 'http://localhost:8087',
      receiptUrl: 'https://qa.favrit.com/nb-no/menu/confirm',
      release: releaseTag,
      showSubsections: true,
      tracingLocationIds: null,
    },
    localProd: {
      baseUrl: 'http://localhost:1234',
      bff: `https://favrit.com/ws/epos`,
      customerOnboardingServiceUrl: `https://favrit.com/ws/customer-onboarding`,
      env,
      hubUrl: `wss://favrit.com/ws/print-service/hub`,
      menuBuilderUrl: 'https://favrit.com/ws/menu-builder',
      ordrServiceUrl: `https://favrit.com/ws/ordr-service`,
      paymentServiceUrl: `https://favrit.com/ws/payment-service-v2`,
      receiptUrl: 'https://favrit.com/nb-no/menu/confirm',
      release: releaseTag,
      showSubsections: true,
      tracingLocationIds: [120896453, 125325560, 125325516],
    },
    localQa: {
      env,
      bff: `https://qa.favrit.com/ws/epos`,
      release: releaseTag,
      ordrServiceUrl: `https://qa.favrit.com/ws/ordr-service`,
      paymentServiceUrl: `https://qa.favrit.com/ws/payment-service-v2`,
      // paymentServiceUrl: 'http://localhost:8087',
      customerOnboardingServiceUrl: `https://qa.favrit.com/ws/customer-onboarding`,
      menuBuilderUrl: 'https://qa.favrit.com/ws/menu-builder',
      // menuBuilderUrl: 'http://localhost:5002',
      baseUrl: 'https://epos.qa.favrit.com',
      receiptUrl: 'https://qa.favrit.com/nb-no/menu/confirm',
      hubUrl: `wss://qa.favrit.com/ws/print-service/hub`,
      showSubsections: true,
      tracingLocationIds: null,
    },
    prod: {
      baseUrl: 'https://epos.favrit.com',
      bff: `https://favrit.com/ws/epos`,
      customerOnboardingServiceUrl: `https://favrit.com/ws/customer-onboarding`,
      env,
      hubUrl: `wss://favrit.com/ws/print-service/hub`,
      menuBuilderUrl: 'https://favrit.com/ws/menu-builder',
      ordrServiceUrl: `https://favrit.com/ws/ordr-service`,
      paymentServiceUrl: `https://favrit.com/ws/payment-service-v2`,
      receiptUrl: 'https://favrit.com/nb-no/menu/confirm',
      release: releaseTag,
      showSubsections: true,
      tracingLocationIds: [120896453, 125325560, 125325516],
    },
    qa: {
      baseUrl: 'https://epos.qa.favrit.com',
      bff: `https://qa.favrit.com/ws/epos`,
      customerOnboardingServiceUrl: `https://qa.favrit.com/ws/customer-onboarding`,
      env,
      hubUrl: `wss://qa.favrit.com/ws/print-service/hub`,
      menuBuilderUrl: 'https://qa.favrit.com/ws/menu-builder',
      ordrServiceUrl: `https://qa.favrit.com/ws/ordr-service`,
      paymentServiceUrl: `https://qa.favrit.com/ws/payment-service-v2`,
      receiptUrl: 'https://qa.favrit.com/nb-no/menu/confirm',
      release: releaseTag,
      showSubsections: true,
      tracingLocationIds: null,
    },
  };
  return c[env];
};

const config = getConfig();
export default config;
